import React from "react";
import { Play } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";

const VideoModal = ({ videoId, onClose }) => (
  <Dialog open={!!videoId} onOpenChange={(open) => !open && onClose()}>
    <DialogContent className="max-w-3xl p-0 overflow-hidden border-0 bg-black">
      <DialogHeader className="sr-only">
        <DialogTitle>Featured video</DialogTitle>
      </DialogHeader>
      <div className="aspect-video w-full">
        {videoId && (
          <iframe
            className="h-full w-full"
            src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        )}
      </div>
      {videoId && (
        <a
          href={`https://www.youtube.com/watch?v=${videoId}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 bg-black py-2.5 text-[13px] font-medium text-white/80 hover:text-white transition-colors"
        >
          <Play size={13} className="fill-white/80" /> Trouble playing? Watch on YouTube →
        </a>
      )}
    </DialogContent>
  </Dialog>
);

export default VideoModal;
